const state = {
    packaging_fee:0,
    delivery_zipcodes:[],
    energy_fee:null,
};

const getters = {
    packaging_fee: state => state.packaging_fee,
    energy_fee: state => state.energy_fee,
    delivery_zipcodes: state => state.delivery_zipcodes,
};

const actions = {
    getPackagingFee({commit, state}){
        axios.get('/api/public/packaging/fee').then(response => {
            commit('setPackagingFee', response.data.data.fee);
        });
    },
    getEnergyFee({commit, state}){
        axios.get('/api/public/energy/fee').then(response => {
            commit('setEnergyFee', response.data.data.fee);
        });
    },
    getDeliveryZipCodes({commit, state}){
        axios.get('/api/public/delivery/zipcodes').then(response => {
            commit('setDeliveryZipcodes', response.data.data);
        });
    }
};

const mutations = {
    setPackagingFee(state, fee){
        state.packaging_fee = fee;
    },
    setEnergyFee(state, fee){
        state.energy_fee = fee;
    },
    setDeliveryZipcodes(state, zipcodes){
        state.delivery_zipcodes = zipcodes;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
